import React from "react";
import { getUrlParam } from "utils/url-param-utils";
import { Button, Card } from "@avenueops/web-components";
import { ArrowTrendingUpIcon, BoltIcon } from "@heroicons/react/24/outline";
import Link from "next/link";

export default function PlanPage(): JSX.Element {
  return (
    <div className="w-full h-full flex flex-col">
      <div className="flex-1 flex flex-col justify-center">
        <div className="w-full flex justify-center">
          <a href="https://useavenue.com">
            <img className="block w-16 h-16 mb-6" src={require("../../public/avenue_icon_black.svg")} alt="Avenue logo" />
          </a>
        </div>
        <div className="flex items-center justify-center gap-10">
          <Card>
            <div className="p-5 flex flex-col items-center w-80 h-112">
              <h1 className="font-medium text-3xl mb-5 text-primary-main flex items-center">
                <BoltIcon className="inline w-6 h-6 fill-current mr-2" />
                Starter Plan
              </h1>
              <p className="prose mb-5 text-gray-500 text-sm">For small teams and startups</p>
              <h2 className="text-sm mb-5">
                <span className="before:content-['$'] before:text-lg before:align-text-top text-3xl font-bold">59</span>
                per month per seat
              </h2>
              <div className="mb-5">
                <Link href="/onboarding">
                  <Button type="PRIMARY" onClick={() => {}}>
                    <Link href="/onboarding">Get started today</Link>
                  </Button>
                </Link>
              </div>
              <ul className="text-gray-900 list-disc mb-5 text-lg marker:content-['✅__']">
                <li>
                  <p>Unlimited alerting</p>
                </li>
                <li>
                  <p>Up to 2 data sources</p>
                </li>
                <li>
                  <p>Up to 5 users</p>
                </li>
                <li>
                  <p>Chat & email support</p>
                </li>
              </ul>
              <div className="flex-1" />
            </div>
          </Card>
          <Card>
            <div className="p-5 flex flex-col items-center w-80 h-112">
              <h1 className="font-medium text-3xl mb-5 text-primary-main flex items-center">
                <ArrowTrendingUpIcon className="inline w-8 h-8 fill-current mr-2" />
                Growth Plan
              </h1>
              <p className="prose mb-5 text-gray-500 text-sm">For growing teams</p>
              <h2 className="text-3xl font-medium mb-5">Contact Sales</h2>
              <div className="mb-5">
                <Button type="SECONDARY">
                  <a href="https://forms.reform.app/qeOU05/early-access/eqb6vq">Get in Touch</a>
                </Button>
              </div>
              <ul className="text-gray-900 list-disc mb-5 text-lg marker:content-['✅__']">
                <li>
                  <p>Unlimited alerting</p>
                </li>
                <li>
                  <p>Avenue playbooking</p>
                </li>
                <li>
                  <p>Unlimited data sources</p>
                </li>
                <li>
                  <p>Whitelabeling</p>
                </li>
                <li>
                  <p>
                    <span className="font-medium">Premium</span> slack support
                  </p>
                </li>
                <li>
                  <p>Chat & email support</p>
                </li>
              </ul>
              <div className="flex-1" />
            </div>
          </Card>
        </div>
      </div>
      <div className="my-6 font-normal text-gray-800 text-center">
        <div className="w-full text-center">
          <p className="text-gray-500">
            Already have an account?{" "}
            <Link href="/signin">
              <span className="text-primary-main hover:underline">Sign in</span>
            </Link>
          </p>
        </div>
        By creating an account, you agree to our
        <br />
        <a href="https://avenue.so/terms-of-service" className="font-semibold hover:underline">
          Terms of Service
        </a>{" "}
        and{" "}
        <a href="https://avenue.so/privacy-policy" className="font-semibold hover:underline">
          Privacy Policy
        </a>
      </div>
    </div>
  );
}
